import { createContext } from 'react'

const AlertConfirmContext = createContext(null)

export default AlertConfirmContext
